export default __webpack_public_path__ + "static/rahu-logo-4a00e41c027b426ba14188953d1e5313.svg";